import styled from 'styled-components/macro'

export const StarsContainer = styled.div<{ $width?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  height: auto;
  display: flex;
  flex-wrap: nowrap;
  width: ${({ $width }) => ($width ? $width + 'px' : 'auto')};
`

export const StarsWrapper = styled.div<{ $count: number; $size: number }>`
  position: relative;
  width: ${({ $count, $size }) => $size * $count}px;
  height: ${({ $size }) => $size + 'px'};
`

export const StyledButton = styled.button`
  background: none;
  border-width: 0;
  padding: 0;
  width: auto;
`
